export default {
  title: 'Fatture ordini',
  list: {
    empty_list: {
      title: 'Nessuna fattura ordini ancora.',
    },
    fields: {
      id: 'Id',
      total: 'Totale',
      date: 'Data',
    },
  },
  export_modal: {
    title: 'Filtro',
    start_date: {
      title: 'Data inizio',
      placeholder: 'data',
    },
    end_date: {
      title: 'Data fine',
      placeholder: 'data',
    },
    button: {
      title1: 'Applica',
      title2: 'Chiudi',
    },
  },
  toasts: {
    failed_to_load_data: 'Caricamento dati non riuscito',
  },
};
